var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.men.list == true)?_c('list',{on:{"item":_vm.menu}}):_vm._e(),(_vm.men.new == true)?_c('new-adviser',{on:{"item":_vm.menu}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }